import { render, staticRenderFns } from "./ShowCourse.vue?vue&type=template&id=2705f4ee&"
import script from "./ShowCourse.vue?vue&type=script&lang=js&"
export * from "./ShowCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports